import React from "react";
import { useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BotonGerericoSalir = () => {
  const navigate = useHistory();

  const handleSalirLimpiar = () => {
    navigate.push("/initialHome");
  };

  return (
    <div className="closeButton-container">
      <IconButton
        aria-label="cerrar"
        size="large"
        onClick={() => {
          handleSalirLimpiar();
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
    </div>
  );
};

export default BotonGerericoSalir;
